<ng-template #nodeTemplate let-node>
  your SVG code here
</ng-template>
